import Repository from "./Repository";
const GetAllStoreSettings = "GetStoreSettings.php";
const PostUpdateStoreSetting = "PostUpdateStoreSetting.php"; // update a single order&collect setting
const PostUpdateStoreSettings = "PostUpdateStoreSettings.php"; // update multiple order&collect settings
const PostUpdateStoreSettingsQS = "PostUpdateStoreSettingsQS.php";
const PostUpdateSgSetting = "PostUpdateSgSetting.php"; // update a single Scan&Get setting

export default {	
	getAllStoreSettings(storeId){
		return Repository.get(`${GetAllStoreSettings}?bid=${storeId}`);		
	},
	postUpdateStoreSetting(payload){
		return Repository.post(`${PostUpdateStoreSetting}`, payload);		
	},
	postUpdateStoreSettings(payload){
		return Repository.post(`${PostUpdateStoreSettings}`, payload);		
	},
	postUpdateStoreSettingsQS(payload){
		return Repository.post(`${PostUpdateStoreSettingsQS}`, payload);		
	},
	postUpdateSgSetting(payload){
		return Repository.post(`${PostUpdateSgSetting}`, payload);		
	}
};
